import { render, staticRenderFns } from "./InventoryAgingValuation.vue?vue&type=template&id=f18ada92&"
import script from "./InventoryAgingValuation.vue?vue&type=script&lang=js&"
export * from "./InventoryAgingValuation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports